export const EventTypeCodes = {
    RecommendJob: 'recommended'
} as const;

export type EventTypeCode = (typeof EventTypeCodes)[keyof typeof EventTypeCodes];
